<div class="component image file-type-icon-media-link col-12">
  <div class="component-content">
    <a href="#"><img src="{{data$ | async}}" alt="Product page" width="10%" height="100%"
        data-variantfieldname="Image"></a><span class="image-caption field-imagecaption"></span>
  </div>
</div>